import {
  // Ashby
  GET_ATS_STATUS,
  CONNECT_ATS,
  DISCONNECT_ATS,
  LIST_ATS_JOBS,
  LINK_ATS_JOB,
  UNLINK_ATS_JOB,
  LIST_ATS_INTERVIEW_STAGES,
  LIST_ATS_CANDIDATES,
  BULK_IMPORT_ATS_CANDIDATES,
  DELETE_ATS_IMPORTED_CANDIDATE,
  GENERATE_ASHBY_ASSESSMENT_API_KEY,
  GET_ASHBY_ASSESSMENT_API_KEY,
  // Greenhouse
  GET_GREENHOUSE_STATUS,
  DISCONNECT_GREENHOUSE,
  LIST_GREENHOUSE_JOBS,
  LINK_GREENHOUSE_JOB,
  UNLINK_GREENHOUSE_JOB,
  LIST_GREENHOUSE_INTERVIEW_STAGES,
  LIST_GREENHOUSE_CANDIDATES,
  BULK_IMPORT_GREENHOUSE_CANDIDATES,
  DELETE_GREENHOUSE_IMPORTED_CANDIDATE,
  GENERATE_GREENHOUSE_ASSESSMENT_API_KEY,
  GET_GREENHOUSE_ASSESSMENT_API_KEY,
  // Shared
  LIST_ATS_IMPORTS,
  GET_ATS_BATCH_STATUS,
} from './queries';

/**
 * Maps provider IDs to their GraphQL queries/mutations and field accessors.
 * This allows shared ATS components to work with any provider.
 */
const providerQueryMap = {
  ashby: {
    // Queries
    GET_STATUS: GET_ATS_STATUS,
    CONNECT: CONNECT_ATS,
    DISCONNECT: DISCONNECT_ATS,
    LIST_JOBS: LIST_ATS_JOBS,
    LINK_JOB: LINK_ATS_JOB,
    UNLINK_JOB: UNLINK_ATS_JOB,
    LIST_INTERVIEW_STAGES: LIST_ATS_INTERVIEW_STAGES,
    LIST_CANDIDATES: LIST_ATS_CANDIDATES,
    BULK_IMPORT_CANDIDATES: BULK_IMPORT_ATS_CANDIDATES,
    LIST_IMPORTS: LIST_ATS_IMPORTS,
    DELETE_IMPORTED_CANDIDATE: DELETE_ATS_IMPORTED_CANDIDATE,
    GET_BATCH_STATUS: GET_ATS_BATCH_STATUS,

    // Data accessors (the field names in GraphQL responses)
    statusField: 'getAshbyStatus',
    jobsField: 'listAshbyJobs',
    stagesField: 'listAshbyInterviewStages',
    candidatesField: 'listAshbyCandidates',
    bulkImportField: 'bulkImportAshbyCandidates',
    importsField: 'listAtsImports',
    batchStatusField: 'getAtsBatchStatus',

    // Variable name mappings for mutations
    jobIdVar: 'ashbyJobId',
    candidateIdKey: 'ashbyCandidateId',
    applicationIdKey: 'ashbyApplicationId',

    // Stage sort field
    stageSortField: 'orderInInterviewPlan',

    // Job location field
    locationField: 'locationName',

    // Assessment mode
    GENERATE_ASSESSMENT_API_KEY: GENERATE_ASHBY_ASSESSMENT_API_KEY,
    GET_ASSESSMENT_API_KEY: GET_ASHBY_ASSESSMENT_API_KEY,
    assessmentKeyField: 'getAshbyAssessmentApiKey',
    generateAssessmentKeyField: 'generateAshbyAssessmentApiKey',
    flowModeField: 'ashbyFlowMode',
    defaultFlowMode: 'webhook_import',
    importModeName: 'Webhook/Manual Import',
    assessmentModeName: 'Assessment',
  },

  greenhouse: {
    // Queries
    GET_STATUS: GET_GREENHOUSE_STATUS,
    CONNECT: CONNECT_ATS, // Placeholder - Greenhouse uses OAuth, but hook needs valid mutation
    DISCONNECT: DISCONNECT_GREENHOUSE,
    LIST_JOBS: LIST_GREENHOUSE_JOBS,
    LINK_JOB: LINK_GREENHOUSE_JOB,
    UNLINK_JOB: UNLINK_GREENHOUSE_JOB,
    LIST_INTERVIEW_STAGES: LIST_GREENHOUSE_INTERVIEW_STAGES,
    LIST_CANDIDATES: LIST_GREENHOUSE_CANDIDATES,
    BULK_IMPORT_CANDIDATES: BULK_IMPORT_GREENHOUSE_CANDIDATES,
    LIST_IMPORTS: LIST_ATS_IMPORTS,
    DELETE_IMPORTED_CANDIDATE: DELETE_GREENHOUSE_IMPORTED_CANDIDATE,
    GET_BATCH_STATUS: GET_ATS_BATCH_STATUS,

    // Data accessors
    statusField: 'getGreenhouseStatus',
    jobsField: 'listGreenhouseJobs',
    stagesField: 'listGreenhouseInterviewStages',
    candidatesField: 'listGreenhouseCandidates',
    bulkImportField: 'bulkImportGreenhouseCandidates',
    importsField: 'listAtsImports',
    batchStatusField: 'getAtsBatchStatus',

    // Variable name mappings for mutations
    jobIdVar: 'greenhouseJobId',
    candidateIdKey: 'greenhouseCandidateId',
    applicationIdKey: 'greenhouseApplicationId',

    // Stage sort field
    stageSortField: 'priority',

    // Job location field
    locationField: 'officeName',

    // Assessment mode
    GENERATE_ASSESSMENT_API_KEY: GENERATE_GREENHOUSE_ASSESSMENT_API_KEY,
    GET_ASSESSMENT_API_KEY: GET_GREENHOUSE_ASSESSMENT_API_KEY,
    assessmentKeyField: 'getGreenhouseAssessmentApiKey',
    generateAssessmentKeyField: 'generateGreenhouseAssessmentApiKey',
    flowModeField: 'greenhouseFlowMode',
    defaultFlowMode: 'harvest_import',
    importModeName: 'Webhook/Manual Import',
    assessmentModeName: 'Assessment',
  },
};

export const getProviderQueries = (providerId) => {
  const queries = providerQueryMap[providerId];
  if (!queries) {
    throw new Error(`Unknown ATS provider: ${providerId}`);
  }
  return queries;
};

export default providerQueryMap;
